export default {
  SECTION_WIDGET_FAQ: {
    container: {
      cellWidth: {
        100: {
          allow: true,
          item: 2,
        },
        66.67: {
          allow: true,
          item: 1,
        },
        58.33: {
          allow: true,
          item: 1,
        },
        50: {
          allow: true,
          item: 1,
        },
        41.67: {
          allow: false,
          item: 0,
        },
        33.33: {
          allow: false,
          item: 0,
        },
        25: {
          allow: false,
          item: 0,
        },
        20: {
          allow: false,
          item: 0,
        },
        16.66: {
          allow: false,
          item: 0,
        },
      }
    },
    "container-fluid": {
      cellWidth: {
        100: {
          allow: true,
          item: 1,
        },
        66.67: {
          allow: true,
          item: 1,
        },
        58.33: {
          allow: true,
          item: 1,
        },
        50: {
          allow: true,
          item: 1,
        },
        41.67: {
          allow: false,
          item: 0,
        },
        33.33: {
          allow: false,
          item: 0,
        },
        25: {
          allow: false,
          item: 0,
        },
        20: {
          allow: false,
          item: 0,
        },
        16.66: {
          allow: false,
          item: 0,
        },
      }
    },
    "fluid": {
      cellWidth: {
        100: {
          allow: true,
          item: 1,
        },
        66.67: {
          allow: true,
          item: 1,
        },
        58.33: {
          allow: true,
          item: 1,
        },
        50: {
          allow: true,
          item: 1,
        },
        41.67: {
          allow: false,
          item: 0,
        },
        33.33: {
          allow: false,
          item: 0,
        },
        25: {
          allow: false,
          item: 0,
        },
        20: {
          allow: false,
          item: 0,
        },
        16.66: {
          allow: false,
          item: 0,
        },
      }
    }
  }
}